import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryShortcuts() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3">
          <div>
            <p className="font-label text-[11px] tracking-[0.26em] uppercase text-accent-500">
              Browse by Category
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              按分类快速找片
            </h2>
          </div>
          <p className="text-xs md:text-sm text-foreground-500 max-w-[420px] leading-relaxed">
            从年代、热度到题材标签，六条不同的路径带你进入片库。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((category) => (
            <Link
              key={category.type}
              to={`/category/${category.type}`}
              className="group relative flex flex-col items-start gap-3 p-4 md:p-5 rounded-lg bg-background-100 border border-background-300/60 hover:border-primary-500/70 transition-colors cursor-pointer overflow-hidden"
            >
              <span className="w-10 h-10 rounded-md bg-primary-500/10 text-primary-700 flex items-center justify-center text-xl group-hover:bg-primary-500 group-hover:text-foreground-950 transition-colors">
                <i className={category.icon} />
              </span>
              <span className="min-w-0">
                <span className="block text-sm md:text-[15px] text-foreground-900 group-hover:text-accent-500 transition-colors">
                  {category.name}
                </span>
                <span className="mt-1 block text-[10px] tracking-[0.14em] uppercase text-foreground-400 truncate">
                  {category.nameEn}
                </span>
              </span>
              <i className="ri-arrow-right-up-line absolute top-4 right-4 text-foreground-400 opacity-0 group-hover:opacity-100 transition-opacity" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}